export abstract class Utils {
  public static includes(array: string[], value: string) {
    return array.indexOf(value) !== -1;
  }
}
